<ng-container *ngFor="let route of accordionRoutes$ | async; let index = index">
    <a
        *ngIf="route.id === 'configurator'"
        [isActive]="isCurrentPath(route.path)"
        [isDisabled]="position === 'bottom'"
        [routerLink]="route.path"
        [step]="route.index + 1"
        i18n-title="@@configurator.steps.title-step-one"
        mg-checkout-accordion-tab
        title="Configure your tesla"
    ></a>
    <a
        *ngIf="route.id === 'contract'"
        [isActive]="isCurrentPath(route.path)"
        [isDisabled]="position === 'bottom'"
        [routerLink]="route.path"
        [step]="route.index + 1"
        i18n-title="@@configurator.steps.title-step-two"
        mg-checkout-accordion-tab
        title="Duration & mileage"
        [withTopEmphasis]="checkIfFirstStepCarShopConfigurator(route)"
    ></a>
    <a
        *ngIf="route.id === 'calibrate'"
        [isActive]="isCurrentPath(route.path)"
        [isDisabled]="position === 'bottom'"
        [routerLink]="route.path"
        [step]="route.index + 1"
        i18n-title="@@configurator.steps.title-step-three"
        mg-checkout-accordion-tab
        title="Deductible & downpayment"
    ></a>
    <a
        *ngIf="route.id === 'confirm'"
        [isActive]="isCurrentPath(route.path)"
        [isDisabled]="position === 'bottom'"
        [routerLink]="route.path"
        [step]="route.index + 1"
        i18n-title="@@configurator.steps.title-step-four"
        mg-checkout-accordion-tab
        title="Contact details"
    ></a>
</ng-container>
